import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  redirect(event) {
    event.preventDefault();

    const dataset = event.currentTarget.dataset;
    const productId = dataset.productId || dataset.product_id;
    const jobId = dataset.jobId || dataset.job_id;
    const url = dataset.url;

    if (productId) {
      sessionStorage.setItem('productId', productId);
    }

    if (jobId) {
      sessionStorage.setItem('jobId', jobId);
    }

    if (url) {
      window.location.href = url;
    }
  }
}
